import type { RouteLocationRaw } from '#vue-router'

export enum Action {
  confirm = 'CONFIRM',
  reload = 'RELOAD',
  route = 'ROUTE',
}

export default defineNuxtPlugin(() => {
  const alerts = ref<Alert[]>([])
  const authErrorAlert = ref<Alert | undefined>(undefined)

  const getAction = (action: Action, to?: RouteLocationRaw) => {
    const actionClasses = 'font-normal text-transform-unset'
    const actions = {
      CONFIRM: [
        {
          class: actionClasses,
          text: 'OK',
          onClick: (_: Event, toastObject: ToastObject) => toastObject.close(),
        },
      ],
      ROUTE: [
        {
          class: actionClasses,
          text: 'View',
          href: to,
        },
      ],
      RELOAD: [
        {
          class: actionClasses,
          text: 'Erneut laden',
          onClick: (_: Event, toastObject: ToastObject) => toastObject.close(),
        },
        {
          class: actionClasses,
          text: 'X',
          onClick: () => Promise.resolve(refreshNuxtData()),
        },
      ],
    }

    return actions[action]
  }

  const show = (message: string, action: Action, to?: RouteLocationRaw) => {
    alerts.value.push({
      id: Date.now(),
      message,
      duration: 5000,
      actions: getAction(action, to),
    })
  }

  const showAuthError = (
    message: string,
    action: Action,
    to?: RouteLocationRaw,
  ) => {
    if (authErrorAlert.value) {
      close(authErrorAlert.value.id)
      setTimeout(() => {
        authErrorAlert.value = {
          id: Date.now(),
          message,
          duration: 5000,
          actions: getAction(action, to),
        }
      }, 500)
    } else {
      authErrorAlert.value = {
        id: Date.now(),
        message,
        duration: 5000,
        actions: getAction(action, to),
      }
    }
  }

  const close = (toastId: number) => {
    alerts.value = alerts.value.filter(({ id }) => id !== toastId)
    authErrorAlert.value = undefined
  }

  return {
    provide: {
      alert: {
        alerts,
        authErrorAlert,
        show,
        close,
        showAuthError,
      },
    },
  }
})
